// import { useEffect } from "react";
// import "../LandingPage.css";

// export default function ClientSection() {
//   useClientCarousel();

//   return (
//     <section className="client-section padding-bottom" id="clientSection">
//       <div className="container">
//         <div className="section-title">
//           <h2> Our Clients </h2>
//         </div>

//         <div className="client-carousel-container">
//           <div className="client-carousel" id="clientCarousel">
//             {[1, 3, 5, 7, 8, 10, 11, 12, 13].map((n) => (
//               <div className="client-widget" key={n}>
//                 <div className="client-inner">
//                   <div className="client-slide-img">
//                     <a href="#">
//                       <img
//                         src={`/assets/images/client-img-${n}.png`}
//                         alt={`Client ${n}`}
//                       />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             ))}
//             {/* Duplicate images for seamless loop */}
//             {[1, 3, 5, 7, 8, 10, 11, 12, 13].map((n) => (
//               <div className="client-widget" key={`duplicate-${n}`}>
//                 <div className="client-inner">
//                   <div className="client-slide-img">
//                     <a href="#">
//                       <img
//                         src={`/assets/images/client-img-${n}.png`}
//                         alt={`Client ${n}`}
//                       />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function useClientCarousel() {
//   useEffect(() => {
//     const carousel = document.getElementById("clientCarousel");
//     if (!carousel) return;

//     let animationId;
//     let isPaused = false;
//     let position = 0;
//     const speed = 1.5; // pixels per frame
//     const itemWidth = 300; // width of each client item
//     const totalItems = 9; // number of unique items

//     const animate = () => {
//       if (!isPaused) {
//         position -= speed;
//         // Reset position when we've scrolled through all unique items
//         if (Math.abs(position) >= itemWidth * totalItems) {
//           position = 0;
//         }
//         carousel.style.transform = `translateX(${position}px)`;
//       }
//       animationId = requestAnimationFrame(animate);
//     };

//     // Start animation
//     animate();

//     // Pause on hover
//     const handleMouseEnter = () => {
//       isPaused = true;
//     };

//     const handleMouseLeave = () => {
//       isPaused = false;
//     };

//     carousel.addEventListener("mouseenter", handleMouseEnter);
//     carousel.addEventListener("mouseleave", handleMouseLeave);

//     return () => {
//       if (animationId) {
//         cancelAnimationFrame(animationId);
//       }
//       carousel.removeEventListener("mouseenter", handleMouseEnter);
//       carousel.removeEventListener("mouseleave", handleMouseLeave);
//     };
//   }, []);
// }

import { useEffect } from "react";
import "../LandingPage.css";

export default function ClientSection() {
  useClientCarousel();

  return (
    <section className="client-section padding-bottom" id="clientSection">
      <div className="container">
        <div className="section-title">
          <h2> Our Clients </h2>
        </div>

        <div className="client-carousel-container">
          <div className="client-carousel" id="clientCarousel">
            {[1, 3, 5, 7, 8, 10, 11, 12, 13].map((n) => (
              <div className="client-widget" key={n}>
                <div className="client-inner">
                  <div className="client-slide-img">
                    <a href="#">
                      <img
                        src={`/assets/images/client-img-${n}.png`}
                        alt={`Client ${n}`}
                      />
                    </a>
                  </div>
                </div>
              </div>
            ))}
            {/* Duplicate images for seamless loop */}
            {[1, 3, 5, 7, 8, 10, 11, 12, 13].map((n) => (
              <div className="client-widget" key={`duplicate-${n}`}>
                <div className="client-inner">
                  <div className="client-slide-img">
                    <a href="#">
                      <img
                        src={`/assets/images/client-img-${n}.png`}
                        alt={`Client ${n}`}
                      />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function useClientCarousel() {
  useEffect(() => {
    const carousel = document.getElementById("clientCarousel");
    if (!carousel) return;

    let animationId;
    let isPaused = false;
    let position = 0;
    const speed = 1.1; // pixels per frame
    const itemWidth = 300; // width of each client item
    const totalUniqueItems = 9; // number of unique items
    const totalWidth = itemWidth * totalUniqueItems; // width of unique items only

    const animate = () => {
      if (!isPaused) {
        position -= speed;

        // When we've scrolled through all unique items (first set),
        // reset position to create seamless loop
        if (Math.abs(position) >= totalWidth) {
          position = 0;
        }

        carousel.style.transform = `translateX(${position}px)`;
      }
      animationId = requestAnimationFrame(animate);
    };

    // Start animation
    animate();

    // Pause on hover
    const handleMouseEnter = () => {
      isPaused = true;
    };

    const handleMouseLeave = () => {
      isPaused = false;
    };

    carousel.addEventListener("mouseenter", handleMouseEnter);
    carousel.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
      carousel.removeEventListener("mouseenter", handleMouseEnter);
      carousel.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);
}
